import { Chip } from "@mui/material";
import { Button } from "components/Button/Button";
import { Input } from "components/Form";
import ModalBox from "components/modal/ModalBox";
import { encryptData } from "config/config";
import useCookie from "hooks/useCookie";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { mapGalleryImage } from "services/centers";

const GalleryModal = ({
  open,
  onClose,
  centerId,
  galleryImage = [],
  closeMainModal,
  centerListing,
}) => {
  const inputRef = useRef();
  const [files, setFiles] = useState([]);
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const { cookies } = useCookie();

  const [mappedImages, setMappedImages] = useState([]);
  const [removedImageArray, setRemovedImageArray] = useState([]);

  //   image selection handler
  const imageHandler = ({ target }) => {
    const { files: images } = target;

    if (Object.entries(images).length > 6) {
      toast.error("Please select 6 images only");
      return;
    }
    let finalImages = [];
    for (let i = 0; i < Object.entries(images).length; i++) {
      if (
        images[i]?.type !== "image/png" &&
        images[i]?.type !== "image/jpeg" &&
        images[i]?.type !== "image/jpg"
      ) {
        toast.error("Please upload only jpeg,jpg and png image");
        return;
      } else {
        let totalImages =
          files.length + Object.entries(images).length + mappedImages.length;
        if (totalImages > 6) {
          toast.error("you can upload 6 images only");
          return;
        } else {
          finalImages.push({
            id: Math.floor(Math.random() * 999999) + 1,
            image: images[i],
          });
        }
      }
      setFiles([...files, ...finalImages]);
    }
  };

  //   remove image function
  const removeImageHandler = (id) => {
    setFiles(files.filter((file) => file.id !== id));
  };

  //   remove image function
  const removeMappedImageHandler = (id) => {
    setRemovedImageArray([...removedImageArray, id]);
    setMappedImages(mappedImages.filter((file) => file.id !== id));
  };

  // image upload handler
  const imageSubmitHandler = async () => {
    if (!files.length && removedImageArray.length <= 0) {
      toast.error("Please select images");
    } else if (
      removedImageArray.length === galleryImage.length &&
      !files.length
    ) {
      toast.error("Please select images");
    } else if (
      files.length + galleryImage.length - removedImageArray.length !==
      6
    ) {
      toast.error("six images must be required");
    } else {
      setSubmitLoading(true);
      const formData = new FormData();
      if (files.length >= 0) {
        files.forEach((file) => {
          formData.append("images", file?.image);
        });
      }
      formData.append(
        "reqData",
        encryptData({
          centerpageId: centerId,
          removedImageArray,
          access_token: cookies,
        })
      );
      try {
        const res = await mapGalleryImage(formData);
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          centerListing();
          modalOnClose();
          closeMainModal();
        } else {
          toast.error(res.message);
          modalOnClose();
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };

  const modalOnClose = () => {
    setFiles([]);
    setRemovedImageArray([]);
    onClose();
  };

  React.useEffect(() => {
    if (galleryImage.length > 0) {
      setMappedImages(galleryImage);
    }
  }, [galleryImage]);

  return (
    <ModalBox
      status={open}
      onClose={modalOnClose}
      custom
      size="sm"
      customizedFooter={
        <div>
          <Button className="mx-2" onClick={modalOnClose}>
            Close
          </Button>
          <Button onClick={imageSubmitHandler} {...submitButtonElement}>
            Save
          </Button>
        </div>
      }
    >
      <div className="row">
        <div className="col-sm-12 col-form-label">
          <div className="col-sm-12 col-form-label">
            <div id="FileUpload">
              <div className="upload-wrapper">
                <div className={`upload `}>
                  <p>Select&nbsp; Gallery &nbsp;Image</p>
                  <input
                    type="file"
                    hidden
                    ref={inputRef}
                    onChange={imageHandler}
                    accept="image/png, image/jpeg, image/jpg"
                    multiple
                  />
                  <button
                    className={`upload__button ${
                      files.length >= 6 && "disabled"
                    }`}
                    onClick={() => inputRef.current.click()}
                    disabled={files.length >= 6}
                  >
                    Select
                  </button>
                </div>
              </div>
            </div>
            <div className="list my-2">
              {files.length > 0 && (
                <>
                  <h5>Selected Images</h5>
                  {files.map(({ id, image }, i) => {
                    return (
                      <div className="my-2" key={id}>
                        <Chip
                          label={image.name}
                          variant="outlined"
                          onDelete={() => {
                            removeImageHandler(id);
                          }}
                          disabled={submitButtonElement.disabled}
                        />
                      </div>
                    );
                  })}
                </>
              )}

              {mappedImages.length > 0 && (
                <>
                  <h5>Mapped Images</h5>
                  {mappedImages.map(({ id, imageUrl }, i) => {
                    return (
                      <div className="my-2" key={id}>
                        <Chip
                          label={imageUrl}
                          variant="outlined"
                          onDelete={() => {
                            removeMappedImageHandler(id);
                          }}
                          disabled={submitButtonElement.disabled}
                        />
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </ModalBox>
  );
};

export default GalleryModal;
